

export const ORGANIZATION_CATEGORY = [
    {
        "id": "93",
        "name": "Private Limited Company",
        "createdAt": "2023-04-03T12:59:06.000Z",
        "updatedAt": "2023-06-12T13:47:58.000Z"
    },
    {
        "id": "94",
        "name": "Public Limited Company",
        "createdAt": "2023-04-03T12:59:16.000Z",
        "updatedAt": "2023-04-03T12:59:16.000Z"
    },
    {
        "id": "95",
        "name": "Partnerships",
        "createdAt": "2023-04-03T12:59:25.000Z",
        "updatedAt": "2023-04-03T12:59:25.000Z"
    },
    {
        "id": "96",
        "name": "LLP Registration",
        "createdAt": "2023-04-03T12:59:35.000Z",
        "updatedAt": "2023-04-03T12:59:35.000Z"
    },
    {
        "id": "97",
        "name": "One Person Company",
        "createdAt": "2023-04-03T12:59:44.000Z",
        "updatedAt": "2023-04-03T12:59:44.000Z"
    },
    {
        "id": "98",
        "name": "Sole Proprietorship",
        "createdAt": "2023-04-03T12:59:52.000Z",
        "updatedAt": "2023-04-03T12:59:52.000Z"
    },
    {
        "id": "99",
        "name": "Section 8 Company",
        "createdAt": "2023-04-03T13:00:00.000Z",
        "updatedAt": "2023-06-05T14:18:06.000Z"
    },
]


export const getOrganizationCategoryNameById = (id) => {
    const category = ORGANIZATION_CATEGORY.find(item => item.id === id);
    return category ? category.name : null;
};
